import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import { findButtonLabelKey, getButtonIcon } from '../../../utils/helpers/buttonIcons';
import '../../../assets/styles/components/Button.css';

export const PrimaryButton = (props) => <Button variant="tempedge-button--state-primary" {...props} />;

export const SuccessButton = (props) => <Button variant="tempedge-button--state-success" {...props} />;

export const DefaultButton = (props) => <Button variant="tempedge-button--state-default" {...props} />;

export const DangerButton = (props) => <Button variant="tempedge-button--state-danger" {...props} />;

export const CtaButton = (props) => <Button variant="tempedge-button--state-cta" pill {...props} />;

/**
 *
 * @param {String} rightSquareSide use this parameter to convert the right side to square
 * @param {String} leftSquareSide use this parameter to convert the left side to square
 * @param {String} label translation key of the button text; falls back to children
 * @param {String} iconKey icon to show; when omitted it is inferred from the label
 * @param {String} appearance "raised" (gradient, default) or "soft" (flat tint, for search actions)
 * @param {Object} rest forwarded to the native button so callers can pass attributes such as data-testid or title
 */

function Button({
  variant,
  type = 'button',
  disabled = false,
  children,
  label,
  onClick,
  rightSquareSide = '',
  leftSquareSide = '',
  pill = false,
  className = '',
  iconKey,
  showIcon = true,
  appearance = 'raised',
  ...rest
}) {
  const { tempedgeTranslator } = useTempEdgeTranslator();
  const content = label ? tempedgeTranslator(label) : children;
  const icon = showIcon ? getButtonIcon(iconKey ?? label ?? findButtonLabelKey(content, tempedgeTranslator)) : null;
  const IconComponent = icon?.Icon;

  const classes = [
    'tempedge-button',
    variant,
    rightSquareSide && 'tempedge-button--square-right-side',
    leftSquareSide && 'tempedge-button--square-left-side',
    pill && 'tempedge-button--pill',
    appearance === 'raised' && 'tempedge-button--raised',
    className
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button {...rest} type={type} className={classes} onClick={onClick} disabled={disabled}>
      {IconComponent && !icon.after && <IconComponent aria-hidden="true" />}
      {content}
      {IconComponent && icon.after && <IconComponent aria-hidden="true" />}
    </button>
  );
}

export default DefaultButton;
